import { useModal } from '~/composables/common/use-modal'
import { EVENT } from '~/configs/page-url'
import { ModalCollection } from '~/constants'

export const useEventEntryHalloween = () => {
  const { openModal, closeModal } = useModal()
  const SECTION_KEY = 'hasShownEventHalloweenPopup'
  const hasModalWelcome = import.meta.client ? useSessionStorage<boolean>(SECTION_KEY, false) : ref<boolean>(false)

  const initModal = () => {
    if (hasModalWelcome.value) return
    openModalEventHalloWeen()
  }

  const openModalEventHalloWeen = () => {
    openModal(ModalCollection.HALLOWEEN_EVENT_ENTRY)
    hasModalWelcome.value = true
  }

  const closeModalEvent = () => {
    closeModal(ModalCollection.HALLOWEEN_EVENT_ENTRY)
    hasModalWelcome.value = true
  }

  const navigateToEventRanking = (): void => {
    closeModal(ModalCollection.HALLOWEEN_EVENT_ENTRY)
    hasModalWelcome.value = true
    void navigateTo(EVENT.HALLOWEEN)
  }

  return {
    initModal,
    openModalEventHalloWeen,
    closeModalEvent,
    navigateToEventRanking
  }
}
